import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getAdministrativeFines,
  hasAdministrativeFines,
} from '../../services/API/administrativeFines';
import { actionTypes, requestFailure, requestSuccess, requestSuccessExisting } from './actions';
import { getAdministrativeFilters } from 'modules/NewTaxes/services/API/administrativeFines';
import {
  failureAdmFiltersRequest,
  successAdmFiltersRequest,
} from 'modules/NewTaxes/redux/administrativeFines/actions';

function* getData({ payload }) {
  const response = yield call(getAdministrativeFines, payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

function* getExistingFines() {
  const response = yield call(hasAdministrativeFines);
  yield put(response.isOk ? requestSuccessExisting(response.data) : requestFailure(response.error));
}

function* getFilters() {
  const response = yield call(getAdministrativeFilters);
  yield put(
    response.isOk
      ? successAdmFiltersRequest(response.data)
      : failureAdmFiltersRequest(response.error),
  );
}

export default function* unexplainedPaymentsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_EXISTING, getExistingFines);
  yield takeLatest(actionTypes.FETCH_ADM_FILTERS_START, getFilters);
}
